<template>
    <div :class="['container', !isZoom ? '' : 'full-screen']">
        <div class="photozone_wrap">
            <transition-group name="fade" tag="div" class="photozone_photo">
                <img v-for="(file, index) in fileList" :key="file.comnFlSqno" v-if="show[index]"
                     :src="getImage(file)" @error="altImgUrl">
            </transition-group>

            <transition-group name="fade">
                <WelcomeText
                    v-for="(file, index) in fileList"
                    :key="file.comnFlSqno"
                    v-if="show[index] && file.dataKdSqno != $_DKD.NEW_WELC"
                    v-bind:file="file"></WelcomeText>
            </transition-group>

            <div class="photozone_btn" style="bottom: 130px;">
                <a href="#" class="open"
                   @click.prevent="showList = !showList">열기</a>
            </div>
            <div class="photozone_list" style="bottom: 274px;" v-show="showList">
                <ul class="scroll">
                    <li v-for="(file, index) in fileList"
                        :key="file.comnFlSqno"
                        @click="setImage(index)">
                        <a href="javascript:void(0)" :class="index == selectedIndex ? 'on' : ''">
                            <img :src="getImage(file)" @error="altImgUrl">
                            <p v-if="file.dataKdSqno != $_DKD.NEW_WELC" v-text="file.val1"></p>
                            <p v-else v-text="file.val2"></p>
                            <i>선택</i>
                        </a>
                    </li>
                </ul>
            </div>

            <div class="zoom_btn">
                <a href="#" :class="!isZoom ? 'in' : 'out'"
                   @click.prevent="isZoom = !isZoom"></a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { $_WC, $_DKD } from '@/confs/common.const.js';
import WelcomeText from "@/views/welcome/WelcomeText.vue";

export default {
    name: "Welcome",
    components: {
        WelcomeText,
    },
    data: function() {
        return {
            selectedIndex: 0,
            showList: false,
            show: [],
            vc: ($_WC.viewScale <= 1 ? 3 : 1),
            isZoom: false,
        }
    },
    computed: {
        ...mapGetters({
            welcomeList: 'getWelcomeList',
            newWelcList: 'getNewWelcList',
        }),
        fileList() {
            let list = [];

            this.welcomeList.forEach(function(welcome){

                // 대표이미지 적용
                welcome.dataFiles.sort(function(pre, cur){
                    return pre.dispSq > cur.dispSq ? 1 : pre.dispSq < cur.dispSq ? -1 : 0;
                });

                welcome.dataFiles.forEach(function(data){
                    for(let key in welcome) {
                        if(key != 'dataFiles') {
                            data[key] = welcome[key];
                        }
                    }
                    list.push(data);
                });
            });

            this.newWelcList.forEach(function(welc) {
                welc.dataFiles.forEach(function(data, idx){
                    // 0번은 원본 1번이 수정본이기 때문에 1번만 표출
                    if(idx == 1) {
                        for(let key in welc) {
                            if(key != 'dataFiles') {
                                data[key] = welc[key];
                            }
                        }
                        list.push(data);
                    }
                });
            });
            
            // 기준일 sorting은 신규 웰컴보드 테스트 종료 후에 진행
            // list = list.sort((pre, cur) => {
            //     return Number(cur.basdtVal) - Number(pre.basdtVal);
            // });

            return list;
        },
    },
    watch: {
        fileList: {
            immediate: true,
            handler: function(newVal, oldVal) {
                let vm = this;
                if(typeof newVal !== 'undefined' && newVal.length > 0) {
                    let showArr = [];

                    newVal.forEach(function(val) {
                        showArr.push(false);
                    });

                    showArr[0] = true;
                    vm.show = showArr;
                }
            }
        }
    },
    methods: {
        getImage(data) {
            if(typeof data !== 'undefined') {
                if(typeof data.comnFlSqno !== 'undefined') {

                    // 개발서버 이미지 요청 URL 변경 처리 필요!!
                    // return $_WC.fileBaseURL + '/image/' + data.comnFlSqno + "?isOrigin=true";
                    // db 저장으로 변경해서 attachFileSaveTpc : db 추가 
                    return $_WC.fileBaseURL + '/image/' + data.comnFlSqno + "?isOrigin=true&attachFileSaveTpc=db";
                } else {
                    return $_WC.assets + "/img/none_img.png";
                }
            }
            return $_WC.assets + "/img/none_img.png";
        },
        altImgUrl(event) {
            event.target.src = $_WC.assets + "/img/none_img.png";
        },
        setImage(index) {
            let showArr = [];
            for(let i = 0; i < this.show.length; i++) {
                showArr[i] = false;
            }
            showArr[index] = true;
            this.show = showArr;
            this.selectedIndex = index;
        },
    }
}
</script>
